import cloneDeep from 'lodash/cloneDeep'

class CompanyAllowedMealsFormMapper {
    toEntity(values) {
        return {
            company: values.company,
            restaurant: values.restaurant,
            mealCodes: values.mealCodes || [],
        }
    }

    fromEntity(entity) {
        const values = cloneDeep(entity)

        // restaurant is embedded as an object on read; keep its IRI for the form
        // model and its name for the read-only display on edit.
        if (values.restaurant && typeof values.restaurant === 'object') {
            values.restaurantName = values.restaurant.name
            values.restaurant = values.restaurant['@id']
        }

        // company is exposed as an IRI on read
        if (values.company && typeof values.company === 'object') {
            values.company = values.company['@id']
        }

        if (!Array.isArray(values.mealCodes)) {
            values.mealCodes = []
        }

        return values
    }
}

export default new CompanyAllowedMealsFormMapper()
